/**
 * relateitriskreducer.js
 **/

import initialState from '../initialstate';
import * as types from '../../actions/actiontypes';

export function relateItRiskReducer(state = initialState.relateItRisks, action) {
	switch (action.type) {
		case types.GET_ALL_RELATED_ITRISKS: {
			return action.response || state;
		}
		default:
			return state;
	}
}

export function deficiencyItRisksReducer(state = initialState.deficiencyItRisks, action) {
	switch (action.type) {
		case types.GET_DEFICIENCY_ITRISKS: {
			return action.response ? {...action.response, controlIds: action.controlIds} : state;
		}
		default:
			return state;
	}
}
